@if (loadingContent) {
  <content-loading-list></content-loading-list>
}

@if (!loadingContent && summary) {

  <!-- State banner (RF-17): system Bootstrap alert; discreet green when healthy -->
  <div class="alert d-flex flex-wrap align-items-center justify-content-between gap-2" [ngClass]="bannerAlertClass()" role="alert">
    <span>
      <strong>{{ ('channel.health.badge.' + bannerClassification()) | translate }}</strong>
      — {{ bannerText() }}
    </span>
    @if (bannerClassification() !== classification.HEALTHY) {
      <a href="javascript:void(0)" class="alert-link text-nowrap" (click)="goToHealth.emit()">
        {{ 'channel.health.summary.bannerAction' | translate }}
      </a>
    }
  </div>

  <div class="summary-grid">

    <!-- Meta info card (RF-18) — provider's own reading of the number -->
    <div class="card summary-card">
      <div class="card-body">
        <div class="summary-card__header">
          <h5>{{ 'channel.health.summary.metaTitle' | translate }}</h5>
          <span class="badge campaign-badge is-neutral text-nowrap">{{ 'channel.health.summary.metaOnlyOfficial' | translate }}</span>
        </div>
        <dl class="summary-meta">
          <div class="summary-meta__row">
            <dt>{{ 'channel.health.summary.numberStatus' | translate }}</dt>
            <dd>{{ numberStatusLabel() }}</dd>
          </div>
          <div class="summary-meta__row">
            <dt>{{ 'channel.health.summary.quality' | translate }}</dt>
            <dd>{{ qualityLabel() }}</dd>
          </div>
          <div class="summary-meta__row">
            <dt>{{ 'channel.health.summary.messagingLimit' | translate }}</dt>
            <dd>{{ messagingLimitLabel() }}</dd>
          </div>
          <div class="summary-meta__row">
            <dt>{{ 'channel.health.summary.phone' | translate }}</dt>
            <dd>{{ summary.metaInfo.displayPhoneNumber || '—' }} {{ countryLabel() }}</dd>
          </div>
          <div class="summary-meta__row">
            <dt>{{ 'channel.health.summary.displayName' | translate }}</dt>
            <dd>{{ summary.metaInfo.verifiedName || channel.name }} <span class="summary-meta__hint">({{ nameStatusLabel() }})</span></dd>
          </div>
        </dl>
      </div>
    </div>

    <!-- Connection card (RF-21) -->
    <div class="card summary-card">
      <div class="card-body">
        <div class="summary-card__header">
          <h5>{{ 'channel.health.summary.connectionTitle' | translate }}</h5>
          <span class="status-badge" [ngClass]="summary.connection.connected ? 'status-badge--connected' : 'status-badge--disconnected'">
            {{ (summary.connection.connected ? 'channel.channelConfig.connected' : 'channel.channelConfig.disconnected') | translate }}
          </span>
        </div>
        <dl class="summary-meta">
          <div class="summary-meta__row">
            <dt>{{ 'channel.health.summary.connectionType' | translate }}</dt>
            <dd>{{ 'channel.health.summary.connectionTypeCloud' | translate }}</dd>
          </div>
          <div class="summary-meta__row">
            <dt>{{ 'channel.health.summary.mode' | translate }}</dt>
            <dd>{{ modeLabel() }}</dd>
          </div>
          <div class="summary-meta__row">
            <dt>{{ 'channel.health.summary.throughput' | translate }}</dt>
            <dd>{{ throughputLabel() }}</dd>
          </div>
          <div class="summary-meta__row">
            <dt>{{ 'channel.health.summary.connectedSince' | translate }}</dt>
            <dd>{{ summary.connection.connectedSince ? (summary.connection.connectedSince | date: 'dd/MM/yyyy') : '—' }}</dd>
          </div>
        </dl>
      </div>
    </div>
  </div>

  <!-- Meta usage of the month — free service-message allowance per number -->
  <health-meta-usage-card [channel]="channel" [refreshTick]="refreshTick" />

  <!-- Hybrid channel: session side + outbound by side and estimated saving (SPEC-2026-10-whatsapp-hybrid-channel RF-22, RF-25) -->
  @if (channel?.hybrid) {
    <health-hybrid-card [channel]="channel" [refreshTick]="refreshTick" />
  }

  <!-- Usage KPIs — 30 days (RF-19) — dashboard stat cards in the dashboard's own grid -->
  <div class="grid-cards mb-3">
    <card-graphic-small-legacy-component
      [label]="formatCount(summary.usage.messages30d)"
      [total]="('channel.health.summary.kpiMessages' | translate) + ' · ' + ('channel.health.summary.kpiPeriod' | translate)" />
    <card-graphic-small-legacy-component
      [label]="formatCount(summary.usage.attendances30d)"
      [total]="('channel.health.summary.kpiAttendances' | translate) + ' · ' + ('channel.health.summary.kpiPeriod' | translate)" />
    <card-graphic-small-legacy-component
      [label]="formatCount(summary.usage.activeContacts)"
      [total]="('channel.health.summary.kpiContacts' | translate) + ' · ' + ('channel.health.summary.kpiPeriod' | translate)" />
  </div>

  <!-- Sent × delivered per day — 30 days (RF-20) -->
  <div class="card">
    <div class="d-flex flex-column card-header">
      <h3>{{ 'channel.channelConfig.metrics' | translate }}</h3>
      <h5 class="text-muted fw-normal">{{ 'channel.health.summary.chartTitle' | translate }} · {{ 'channel.health.summary.chartSubtitle' | translate }}</h5>
    </div>
    <div class="card-body summary-chart">
      @if (chartData.length > 0) {
        <ngx-charts-bar-vertical-2d
          [xAxis]="true"
          [yAxis]="true"
          [results]="chartData"
          [groupPadding]="2"
        />
      } @else {
        <p class="text-muted mb-0">{{ 'channel.health.summary.chartEmpty' | translate }}</p>
      }
    </div>
  </div>
}
